import { atom } from "recoil";

export const defaultWarningProps = {
  title: "",
  visible: false,
  onClose: undefined,
  onOK: undefined,
  options: {
    showInputReason: false,
  },
};

export const warningProps = atom({
  key: "warningProps",
  default: defaultWarningProps,
});

export const connection = atom({
  key: "connection",
  default: true,
});
